var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-components-bubbles-button",class:{'stream-components-bubbles-button--active': _vm.active},style:({ top: `calc(${_vm.top}% - 20px)`, left: `calc(${_vm.left}% - 20px)` }),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }